<template>
    <div class="left400 fl" style="border:none;">
        <div class="bor">
        <dl class="fix" style="position: relative;">
            <dt style="width: 320px;height: 205px;">
                <a :href="`/activityDetail?id=${arr[0].id}`" target="_blank"> 
                    <img :src="arr[0].image" :alt="arr[0].title">
                </a>
            </dt>
            <dd>
                <a target="_blank" :title="arr[0].title" :href="`/activityDetail?id=${arr[0].id}`">
                    {{arr[0].title}}
                </a>
                <p v-html="arr[0].content"></p>
                <div class="view-origin" @click="goDetail(arr[0].id)">查看原文></div>
            </dd>
                    <div class="blank20"></div>
        </dl>
        <div class="lx-index-news">
            <ul class="clearfix">
                <li v-for="(item) in arr.slice(0,6)" :key="item.id" class="pr fl" @click="goDetail(item.id)">
                    <span>{{item.create_time}}</span>
                    <img src="../../assets/news-remark.png">
                    <a target="_blank" :title="item.title" :href="`/activityDetail?id=${item.id}`" >{{item.title}}</a>   
                </li>
            </ul>
        </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        arr:{
            type:Array,
            default:() => [],
        },
    },
    computed:{
        
    },
    data() {
        return {
            selectIndex: 2,
        }
    },
    created() {
        //this.getNewsFunc()
    },
    methods:{
        goDetail(id){
            this.$router.push(`/activityDetail?id=${id}`)
        },
        changeIndex(index){
            this.selectIndex = index;
            this.getNewsFunc();
        },
        async getNewsFunc(){
            try {
                const res = await this.$http.get('/api/news/information', {
                    limit: 10,
                    type: this.selectIndex,
                });
                console.log(res, 'news')
                res.length&&(this.arr = res);
            } catch (error) {
                this.$toast(error.message||'请求失败');
            }
        }
    }
}
</script>
<style lang="scss" scoped>
a,a:link { cursor:pointer; color: #333;text-decoration: none;}
a:hover{ text-decoration: none; color:#04407D;}

.left820{ width:735px;}
.left400{
    width:735px;
    height: 485px;
    border: 1px solid #ebecee;
    background-color: #fff;
    font-family: "Microsoft YaHei","微软雅黑" !important;display: flex;
}
.title-list{
    width: 65px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .is-select{
        background-color: #fff !important;
        color: #2E3E4E !important;
    }
    div{
        text-align: center;
        writing-mode: vertical-rl;
        width: 100%;
        height: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background-color: #d2d4d9;
        color: #2e3e4e;
        text-align: left;
        font-size: 20px;
        font-weight: 400;
    }
}
.left400 .bor{width:730px; padding:20px 0;}
.blank20 { clear:both; height:15px; overflow:hidden; display:block; }
.left400 dl { margin:0 0px;}
.left400 dl dt { text-align:center; float:left; margin-right:20px; overflow:hidden;}
.left400 dl dt img{width: 320px;height:205px;-webkit-transition:all .3s ease;-moz-transition:all .3s ease;-ms-transition:all .3s ease;-o-transition:all .3s ease;transition:all .3s ease}
.left400 dl dt :hover img{-webkit-transform:scale(1.06,1.06);-moz-transform:scale(1.06,1.06);-ms-transform:scale(1.06,1.06);-o-transform:scale(1.06,1.06);transform:scale(1.06,1.06)}
.left400 dl dd { width:330px; float:left; overflow:hidden;}
.left400 dl dd a { display:block;width:100%; color: #2e3e4e; padding-bottom:6px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;text-align: left;
font-size: 20px;
font-weight: 600;
font-family: "PingFang SC";
border-bottom: 1px solid #EAEAEA;
padding-bottom: 15px;
}
.left400 dl dd p {  overflow: hidden; text-overflow: ellipsis;word-break: break-all;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 5;
color: #7d7d7d;
padding-top: 15px;
font-size: 14px;
line-height: 21px;
font-family: "Microsoft YaHei";
}
.view-origin{
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: right;
    color: #666;
    font-size: 14px;
    // background-color: #AA2F2A;
    position: absolute;
    bottom: 5px;
    right: 10px;
    cursor: pointer;
}
.blank10{ clear:both; height:10px; overflow:hidden; display:block; font-size:1px; }

.lx-index-news{overflow:auto;height: 238px;}
.lx-index-news ul{ margin:0 10px}
.lx-index-news ul li{height:38px;line-height:38px;vertical-align:top;
    border-bottom: 1px dashed #B6B2B2;
}
.lx-index-news ul li a{ float:left;display:block;height:35px;line-height:35px;width:450px; font-size:13px;overflow:hidden;font-family: "Microsoft YaHei","微软雅黑" !important;}
.lx-index-news ul li a:hover{
    // color: #d9230f;
    text-decoration: underline;
}
.lx-index-news ul li span{ float:right;font-size: 12px !important; color: #999; text-align:right;font-family: "Microsoft YaHei","微软雅黑" !important;}
.lx-index-news ul li img{
    width: 18px;
    height: 18px;
    float:left;
    margin-right: 5px;
    margin-top: 7px;
}
</style>
